import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import Icon from '../../../components/Icon';
import PlItemList from './Placeholders/PlItemList';
import { makeQAAttributes } from '../../../utils/qaAttributes';
import { QA_LIST } from '../../../constants/qaAttributes';

const List = ({
  items,
  loading,
  hideItems,
  qaAttribute,
}) => (
  <ul className="sp-help-list">
    {!hideItems && items.map(el => (
      <li key={el.id || el.slug} className="sp-help-list__item" {...(qaAttribute ? makeQAAttributes(`${qaAttribute}-${el.id || el.slug}`) : {})}>
        <span className="sp-help-list__desc">
          <Link to={el.link} className="sp-link sp-text--semibold">
            <span className="sp-help-list__title" {...makeQAAttributes(QA_LIST.ITEM_TITLE)}>
              {el.title}
            </span>
            {el.isActive && <span className="sp-help-list__status" />}
          </Link>
          <span className="sp-help-list__subtitle" {...makeQAAttributes(QA_LIST.ITEM_DESCRIPTION)}>
            {el.description}
          </span>
        </span>
        {el.status && (
          <span className="sp-status-indicator" {...makeQAAttributes(QA_LIST.ITEM_STATUS)}>
            <span className="sp-status-indicator__icon">
              <Icon id={el.status.icon} />
            </span>
            <span
              className={classNames('sp-status-indicator__title', {
                [`sp-status-indicator__title--${el.status.class}`]: el.status.class,
              })}
            >
              {el.status.title}
            </span>
          </span>
        )}
        {el.rate && (
          <span className="sp-status-indicator" {...makeQAAttributes(QA_LIST.ITEM_RATE)}>
            <span className="sp-status-indicator__icon">
              <Icon id={el.rate.icon} size="24" />
            </span>
            <span className="sp-status-indicator__title sp-status-indicator__title--rating">
              {el.rate.text}
            </span>
          </span>
        )}
        {el.emptyRate && <span />}
      </li>
    ))}
    {loading && <PlItemList />}
  </ul>
);

List.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool.isRequired,
  hideItems: PropTypes.bool,
  qaAttribute: PropTypes.string,
};

List.defaultProps = {
  hideItems: false,
  qaAttribute: '',
};

export default List;
